import autoBind from 'react-autobind';
import {ConfirmModal} from '../../shared/components';
import {connect} from 'react-redux';
import Immutable from 'immutable';
import toastr from 'toastr';
import {cancelEnableUser, enableUser} from '../actions/creators';
import React, {Component, PropTypes} from 'react';

class ConfirmEnableUserModal extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  handleConfirm() {
    const {handleConfirm, user} = this.props;

    handleConfirm(user.get('id'))
      .catch(error => {
        toastr.error('An error occurred while attempting to enable the user.', 'Error');
        throw error;
      });
  }

  render() {
    const {
      handleCancel,
      show,
      processing,
      user
    } = this.props;

    return (
      <ConfirmModal
        show={show}
        title="Confirm Enable"
        message={
          <span>Please confirm that you want to enable <strong>{user.get('email')}</strong>.</span>}
        messageStyle="warning"
        processing={processing}
        onCancel={handleCancel}
        onConfirm={this.handleConfirm} />
    );
  }
}

ConfirmEnableUserModal.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  processing: PropTypes.bool,
  show: PropTypes.bool,
  user: PropTypes.instanceOf(Immutable.Map)
};

function mapStateToProps(state) {
  const {enableUser} = state.features.users.modals;

  return {
    show: enableUser.get('show'),
    processing: enableUser.get('processing'),
    user: enableUser.get('user')
  };
}

export default connect(
  mapStateToProps,
  {
    handleCancel: cancelEnableUser,
    handleConfirm: enableUser
  }
)(ConfirmEnableUserModal);



// WEBPACK FOOTER //
// ./app/features/users/containers/ConfirmEnableUserModal.js